module.exports = __webpack_public_path__ + "static/media/IMG-5.adf6e496.jpg";